export default "__VITE_ASSET__CO4mT3ns__"